import styles from './textInput.module.scss';
import IFormInputProps from './interfaces/IFormInputProps';
import TextInputTypes from './enums/TextInputTypes';

interface IProps extends IFormInputProps {
    value?: string,
    type?: TextInputTypes,
    maxLength?: number,
    pattern?: string,
    placeholder?: string,
    forwardedRef?: React.RefObject<HTMLInputElement>,
    readOnly?:boolean,
}

const TextInput: React.FC<IProps> = (props) => {
    const { onChangeValue, forwardedRef, readOnly, type = TextInputTypes.TEXT, ...passThroughProps } = props;
    const handleChange = (evt: React.FormEvent<HTMLInputElement>) => {
        if (evt.currentTarget.validity.valid === true) {
            onChangeValue!(evt);
        }
        else {
            evt.currentTarget.value = '';
        }
    }

    const pattern = type === TextInputTypes.DIGIT ? "\\d*" : undefined;
    const onInput = type === TextInputTypes.DIGIT ? handleChange : onChangeValue;

    return (<input
        readOnly={readOnly}
        pattern={pattern}
        ref={forwardedRef}
        className={styles.input}
        onChange={onInput}
        type={type}
        {...passThroughProps} />);
}

export default TextInput;